<template>
  <div class="k-banner" :class="`k-banner--${type}`">
    <div
      v-if="tagline || $slots.tagline"
      class="k-banner__item k-banner__tagline"
    >
      <slot name="tagline">
        <span v-html="tagline"></span>
      </slot>
    </div>
    <div v-if="title || $slots.title" class="k-banner__item k-banner__title">
      <slot name="title">
        <span v-html="title"></span>
      </slot>
    </div>
    <div
      v-if="subtitle || $slots.subtitle"
      class="k-banner__item k-banner__subtitle"
    >
      <slot name="subtitle">
        <span v-html="subtitle"></span>
      </slot>
    </div>
    <div
      v-if="additional || $slots.additional"
      class="k-banner__item k-banner__additional"
    >
      <slot name="additional">
        <span v-html="additional"></span>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommonBanner",
  props: {
    type: {
      type: String,
      default: "positive",
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    tagline: {
      type: String,
      default: "",
    },
    additional: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.k-banner {
  font-family: Roboto-Bold;
  text-align: left;
  padding: 24px 16px;

  &__item {
    position: relative;

    & + & {
      &::before {
        content: "";
        display: block;
        height: 4px;
      }
    }
  }

  &--positive {
    color: white;
    background-color: $colorLightGreen;
  }

  &--neutral {
    color: $colorGreyishBrown;
    background-color: white;
  }

  &--negative {
    color: white;
    background-color: $colorGreyishBrown;
  }

  &__tagline {
    font-size: 24px;
    line-height: 28px;
  }

  &__title {
    font-size: 50px;
    line-height: 56px;
  }

  &__subtitle {
    font-size: 24px;
    line-height: 28px;
  }

  &__additional {
    font-family: Roboto-Regular;
    font-size: 17px;
    line-height: 20px;
  }
}
</style>
